import AwardBadges from "@components/quiz/AwardBadges"
import { StarIcon } from "@heroicons/react/24/solid"
import useCountUp from "@hooks/useCountUp"
import { useTranslation } from "react-i18next"

const AVATARS = ["🧑‍🎓", "👩‍💼", "👨‍🔬", "👩‍🏫", "🧑‍💻"]

export default function SocialProofVisual() {
  const { t } = useTranslation()
  const ratings = useCountUp({ durationMs: 1400, target: 19 })

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex -space-x-3">
        {AVATARS.map((avatar, index) => (
          <span
            className="flex h-14 w-14 animate-scale-in items-center justify-center rounded-full border-4 border-vm-cream bg-vm-primary-soft text-2xl"
            key={avatar}
            style={{ animationDelay: `${index * 90}ms` }}
          >
            {avatar}
          </span>
        ))}
      </div>

      <div className="text-center">
        <p className="text-6xl font-extrabold tracking-tight text-vm-primary">
          {Math.round(ratings)}K+
        </p>
        <p className="mt-1 text-sm font-medium text-vm-muted">
          {t("pages.onboarding.visuals.socialProof.ratings")}
        </p>
      </div>

      <div className="flex animate-fade-up items-center gap-1 [animation-delay:600ms]">
        {[0, 1, 2, 3, 4].map((star) => (
          <StarIcon className="h-6 w-6 text-vm-yellow" key={star} />
        ))}
        <span className="ml-2 text-sm font-semibold text-vm-ink">
          {t("pages.onboarding.visuals.socialProof.rating")}
        </span>
      </div>

      <AwardBadges className="animate-fade-up [animation-delay:800ms]" />
    </div>
  )
}
